// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"cta-small-component_uk-open__r04eA","grecaptcha-badge":"cta-small-component_grecaptcha-badge__DlpD4","root":"cta-small-component_root__8Kl2Y","inner":"cta-small-component_inner__N9duJ","title":"cta-small-component_title__tQkZ2","icon":"cta-small-component_icon__7pAvJ"};
    if(module.hot) {
      // 1793877040174
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  